import { useSyncExternalStore } from 'react';
import { getCasinoAccessToken, subscribeToCasinoAccessToken } from '../utils/api';

const useCasinoAccessToken = () => useSyncExternalStore(subscribeToCasinoAccessToken, getCasinoAccessToken);

export default useCasinoAccessToken;
